import { ApolloError, useQuery } from '@apollo/client'
import { COUNTRIES_OF_LEGAL_ENTITIES } from '../Queries'
import { CountriesOfLegalEntitiesQuery, CountriesOfLegalEntitiesQueryVariables } from '../../../types'

export default (): { data: CountriesOfLegalEntitiesQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<CountriesOfLegalEntitiesQuery, CountriesOfLegalEntitiesQueryVariables>(
    COUNTRIES_OF_LEGAL_ENTITIES,
  )

  return { data, error, loading }
}
